import { useRef } from "react";
import { deleteIcon, file, fileupload } from "../../../../../constant/icons";
import { FileUpload } from "../../../type";
import { message } from "../../../../../components/toast";
import { ACCEPTS_ONLY } from "../../../message";
import { Button } from "reactstrap";

const FileAccept = ["csv", "xlsx"];
const maxSize = 3 * 1024 * 1024; // 3 MB

const BrowserFile = (props: any) => {
  const { fileUpload, onFileUpdate, onFileUpdateRefresh, isMultipleFileAllowed = false } = props;
  const fileInputRef: any = useRef(null);

  const onRemoveFile = (index?: number) => {
    if (isMultipleFileAllowed && typeof index === "number") {
      const updatedFiles = fileUpload.filter((_: any, i: number) => i !== index);
      onFileUpdate(updatedFiles);
    } else {
      onFileUpdate([]);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    onFileUpdateRefresh(true);
  };

  const addFiles = (e: any) => {
    const selectedFiles = e?.target?.files;
    if (!selectedFiles?.length) return;

    let UploadFile: FileUpload[] = [];
    let invalidFile = false;
    let tooBigFile = false;

    const filesToProcess = isMultipleFileAllowed ? selectedFiles : [selectedFiles[0]];

    for (let i = 0; i < filesToProcess.length; i++) {
      const fileObj = filesToProcess[i];
      const extension = fileObj.name.split(".").pop().toLowerCase();

      if (fileObj.size > maxSize) {
        tooBigFile = true;
      } else if (FileAccept.includes(extension)) {
        UploadFile.push({
          file: fileObj,
          selectedSheet: [],
        });
      } else {
        invalidFile = true;
      }
    }

    if (tooBigFile) {
      message(
        "warning",
        "Your file size is too large. Please split it into smaller chunks and try again. Each file should not exceed 3 MB."
      );
    } else if (invalidFile) {
      message("warning", ACCEPTS_ONLY);
    } else {
      const finalFiles = isMultipleFileAllowed ? [...fileUpload, ...UploadFile] : UploadFile;
      onFileUpdate(finalFiles);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    onFileUpdateRefresh(true);
  };

  return (
    <div className="dropzone mb-3">
      <label htmlFor="browserfile" className="dropzone-container">
        <div className="file-icon">
          {(!fileUpload?.length || fileUpload?.length <= 0) && fileupload.icon}
        </div>

        {(!fileUpload?.length || fileUpload?.length <= 0) && (
          <div className="dropzone-title">
            Drag and drop your file{isMultipleFileAllowed ? "s" : ""} or
            <span className="browse"> browse</span>{" "}
            your file{isMultipleFileAllowed ? "s" : ""}
          </div>
        )}

        <div className="attachment-data-list">
          {fileUpload.map((item: FileUpload, index: number) => (
            <div className="attachment-data" key={index}>
              <a title="File" className="file-box">
                {file.icon}
                <p>{item.file.name}</p>
              </a>
              <Button
                className="remove-box"
                title="remove"
                onClick={(e) => {
                  e.preventDefault();
                  onRemoveFile(index);
                }}
              >
                {deleteIcon.icon}
              </Button>
            </div>
          ))}
        </div>
      </label>

      <input
        ref={fileInputRef}
        id="browserfile"
        name="browserfile"
        type="file"
        className="form-control"
        onChange={addFiles}
        multiple={isMultipleFileAllowed} 
      />
    </div>
  );
};

export { BrowserFile };
